import { render, staticRenderFns } from "./CreateLegalProviderModal.vue?vue&type=template&id=2122bb85&scoped=true&"
import script from "./CreateLegalProviderModal.vue?vue&type=script&lang=js&"
export * from "./CreateLegalProviderModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateLegalProviderModal.vue?vue&type=style&index=0&id=2122bb85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2122bb85",
  null
  
)

export default component.exports